<template>
    <section class="realtive md:py-24 py-16" id="engine">
        <div class="container relative">
            <div class="grid grid-cols-1 pb-6 text-center">
                <h3 class="font-semibold text-2xl leading-normal mb-4">{{ $t('engine.1') }}</h3>

                <p class="text-slate-400 max-w-xl mx-auto">{{ $t('engine.2') }}</p>
            </div><!--end grid-->

            <div class="grid md:grid-cols-12 grid-cols-1 mt-6 gap-6">
                <div class="lg:col-span-4 md:col-span-5">
                    <div class="sticky top-20">
                        <ul class="flex-column p-6 bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 rounded-md" id="myTab" data-tabs-toggle="#myTabContent" role="tablist">
                            <li role="presentation">
                                <button class="px-4 py-2 text-start text-base font-medium rounded-md w-full duration-500" :class="activeindex === '1' ? 'text-white bg-teal-500' : 'hover:text-teal-500 dark:hover:text-white hover:bg-slate-50 dark:hover:bg-slate-800'" @click="tabChange('1')">
                                    <span class="text-lg mt-2 block">{{ $t('engine.3') }}</span>
                                    <span class="block mt-2">{{ $t('engine.4') }}</span>
                                </button>
                            </li>
                            <li role="presentation">
                                <button class="px-4 py-2 text-start text-base font-medium rounded-md w-full duration-500 mt-6" :class="activeindex === '2' ? 'text-white bg-teal-500' : 'hover:text-teal-500 dark:hover:text-white hover:bg-slate-50 dark:hover:bg-slate-800'" @click="tabChange('2')">
                                    <span class="text-lg mt-2 block">{{ $t('engine.6') }}</span>
                                    <span class="block mt-2">{{ $t('engine.7') }}</span>
                                </button>
                            </li>
                            <li role="presentation">
                                <button class="px-4 py-2 text-start text-base font-medium rounded-md w-full duration-500 mt-6" :class="activeindex === '3' ? 'text-white bg-teal-500' : 'hover:text-teal-500 dark:hover:text-white hover:bg-slate-50 dark:hover:bg-slate-800'" @click="tabChange('3')">
                                    <span class="text-lg mt-2 block">{{ $t('engine.9') }}</span>
                                    <span class="block mt-2">{{ $t('engine.10') }}</span>
                                </button>
                            </li>
                            <li role="presentation">
                                <button class="px-4 py-2 text-start text-base font-medium rounded-md w-full duration-500 mt-6" :class="activeindex === '4' ? 'text-white bg-teal-500' : 'hover:text-teal-500 dark:hover:text-white hover:bg-slate-50 dark:hover:bg-slate-800'" @click="tabChange('4')">
                                    <span class="text-lg mt-2 block">{{ $t('engine.28') }}</span>
                                    <span class="block mt-2">{{ $t('engine.29') }}</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="lg:col-span-8 md:col-span-7">
                    <div id="myTabContent" class="p-6 bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 rounded-md">

                        <div :class="activeindex !== '1' ? 'hidden' : '' " role="tabpanel" aria-labelledby="profile-tab" >
                            <div class="mt-6">
                                <h5 class="text-lg font-medium">{{ $t('engine.5.51') }}</h5>
                                <p class="text-slate-400 mt-4">{{ $t('engine.5.52') }}</p>
                                <p class="text-slate-400 mt-4">{{ $t('engine.5.53') }}</p><br>
                                <h5 class="text-lg font-medium">{{ $t('engine.5.54') }}</h5>
                                <p class="text-slate-400 mt-4">{{ $t('engine.5.55') }}</p>
                                <p class="text-slate-400 mt-4">{{ $t('engine.5.56') }}<br><ul><li v-for="feature in $tm('engine.5.57')" :key="feature">✔️ {{ feature }}</li></ul></p>
                                <p class="text-slate-400 mt-4">{{ $t('engine.5.58') }}</p>
                                <div class="mt-4">
                                    <a href="https://doc.ummonlab.com" target="_blank" class="text-teal-500">{{ $t('engine.40') }} <i class="mdi mdi-chevron-right align-middle"></i></a>
                                </div>
                             </div>
                        </div>

                        <div :class="activeindex !== '2' ? 'hidden' : '' " id="dashboard" role="tabpanel" aria-labelledby="dashboard-tab">
                            <div class="mt-6">
                                <h5 class="text-lg font-medium">{{ $t('engine.8.81') }}</h5>
                                <p class="text-slate-400 mt-4">{{ $t('engine.8.82') }}</p>
                                <p class="text-slate-400 mt-4"><ul><li v-for="feature in $tm('engine.8.83')" :key="feature">✔️ {{ feature }}</li></ul></p><br>
                                <h5 class="text-lg font-medium">{{ $t('engine.8.84') }}</h5>
                                <p class="text-slate-400 mt-4">{{ $t('engine.8.85') }}</p>
                                <p class="text-slate-400 mt-4">✔️ <b>{{ $t('engine.8.86') }}</b></p>
                                <p class="text-slate-400 mt-4">{{ $t('engine.8.87') }}</p>
                                <p class="text-slate-400 mt-4">{{ $t('engine.8.88') }}</p>
                                <p class="text-slate-400 mt-4"><ul><li v-for="feature in $tm('engine.8.89')" :key="feature">✔️ {{ feature }}</li></ul></p>
                                <p class="text-slate-400 mt-4">{{ $t('engine.8.90') }}</p>
                                <div class="mt-4">
                                    <a href="https://doc.ummonlab.com" target="_blank" class="text-teal-500">{{ $t('engine.40') }} <i class="mdi mdi-chevron-right align-middle"></i></a>
                                </div>
                            </div>
                        </div>

                        <div :class="activeindex !== '3' ? 'hidden' : '' " id="settings" role="tabpanel" aria-labelledby="settings-tab">
                            <div class="mt-6">
                                <h5 class="text-lg font-medium">{{ $t('engine.11') }}</h5>
                                <p class="text-slate-400 mt-4">{{ $t('engine.12') }}</p><br>
                                <h5 class="text-lg font-medium">{{ $t('engine.13') }}</h5>
                                <p class="text-slate-400 mt-4">{{ $t('engine.14') }}</p><br>
                                <h5 class="text-lg font-medium">{{ $t('engine.15') }}</h5>
                                <p class="text-slate-400 mt-4">{{ $t('engine.16') }}</p><br>
                                <h5 class="text-lg font-medium">{{ $t('engine.17') }}</h5>
                                <p class="text-slate-400 mt-4">{{ $t('engine.18') }}</p><br>
                                <h5 class="text-lg font-medium">{{ $t('engine.19') }}</h5>
                                <p class="text-slate-400 mt-4">{{ $t('engine.20') }}</p><br>
                                <h5 class="text-lg font-medium">{{ $t('engine.21') }}</h5>
                                <p class="text-slate-400 mt-4">{{ $t('engine.22') }}</p><br>
                                <h5 class="text-lg font-medium">{{ $t('engine.23') }}</h5>
                                <p class="text-slate-400 mt-4">{{ $t('engine.24') }}</p><br>
                                <h5 class="text-lg font-medium">{{ $t('engine.25') }}</h5>
                                <p class="text-slate-400 mt-4">{{ $t('engine.26') }}</p>
                                <p class="text-slate-400 mt-4">{{ $t('engine.27') }}</p>
                                <div class="mt-4">
                                    <a href="https://doc.ummonlab.com" target="_blank" class="text-teal-500">{{ $t('engine.40') }} <i class="mdi mdi-chevron-right align-middle"></i></a>
                                </div>
                            </div>
                        </div>

                        <div :class="activeindex !== '4' ? 'hidden' : '' " id="settings" role="tabpanel" aria-labelledby="settings-tab">
                            <div class="mt-6">
                                <h5 class="text-lg font-medium">{{ $t('engine.30') }}</h5>
                                <p class="text-slate-400 mt-4">{{ $t('engine.31') }}</p><br>
                                <h5 class="text-lg font-medium">{{ $t('engine.32') }}</h5>
                                <p class="text-slate-400 mt-4">{{ $t('engine.33') }}</p>
                                <p class="text-slate-400 mt-4">{{ $t('engine.34') }}</p>
                                <p class="text-slate-400 mt-4">{{ $t('engine.35') }}</p>
                                <p class="text-slate-400 mt-4">{{ $t('engine.36') }}</p><br>
                                <h5 class="text-lg font-medium">{{ $t('engine.37') }}</h5>
                                <p class="text-slate-400 mt-4">{{ $t('engine.38') }}</p>
                                <p class="text-slate-400 mt-4">{{ $t('engine.39') }}</p><br>
                                <div class="mt-4">
                                    <a href="https://doc.ummonlab.com" target="_blank" class="text-teal-500">{{ $t('engine.40') }} <i class="mdi mdi-chevron-right align-middle"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!--end grid-->
        </div><!--end container-->
    </section>
</template>


<script>

export default {
    data(){
        return{
            activeindex:"1",
        }
    },

    name: "EngineComponent",

    methods:{
        tabChange(index) {
            this.activeindex = index
        },
    }
}
    

</script>